// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getISOWeekYear as fn } from "../getISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getISOWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getISOWeekYearWithOptions;
